import React from 'react';
import { Link } from 'react-router-dom';
import './footer.scss';
const Footer = () => {
    return (
        <>
            <section className="main-footer ">
               <div className="container">
                <div className="upper-logo">
                    <img src="\footer-logo.svg" alt="img" className='img-fluid' />
                </div>
                <div className="bottom-content">
                    <div className="left">
                        <p>©2023 <span>KingKong Doge</span>, All Rights Reserved</p>
                    </div>
                    <div className="mid">
                        <ul>
                            <li>
                                <a href="">Discord</a>
                            </li>
                            <li>
                                <a href="">twitter</a>
                            </li>
                            <li>
                                <a href="">etherscan</a>
                            </li>
                            <li>
                                <a href="">forums</a>
                            </li>
                        </ul>
                    </div>
                    <div className="right">
                        <p>Privacy Policy  |  Terms of Use</p>
                    </div>
                </div>
               </div>
            </section>
         

        </>
    )
}

export default Footer;
